import { createUseStyles } from "react-jss";

const useGlobalStyle = createUseStyles({
  "@global": {
    "#app": {
      paddingTop: 64,
      "@media screen and (min-width: 992px)": {
        paddingTop: 100,
      },
      "@media screen and (min-width: 1200px)": {
        paddingTop: 152,
      },
    },
    ".desktop-modal-portal.classic-theme .item-modal-body.item-modal-body--after-open.item-modal-type-article .header-wrapper": {
      width: "calc(100% - 4rem)",
      "@media screen and (min-width: 992px)": {
        width: "93rem",
      },
      "@media screen and (min-width: 1200px)": {
        width: "116rem",
      },
    },
    ".item-modal-actions-row": {
      "@media screen and (max-width: 780px)": {
        marginTop: "unset",
      },
    },
    "li": {
      display: "block",
    },
    ".live-board-desktop .items-header .categories-container.tab .categories-renderer .parent-category ul": {
      maxHeight: 'unset',
    },
    ".live-board .promotion-area-container .promotion-items.columns-container .promotion-item .promotion-item-text":
    {
      "& h2": {
        color: "#25282d !important",
        fontFamily: "LexendDeca-Bold",
        fontWeight: "bold",
        fontSize: "2rem",
        lineHeight: "1.5em",
      },
      "& p": {
        color: "#484b58 !important",
        fontFamily: "Inter-Medium",
        fontWeight: "normal",
        fontSize: "1.4rem",
        lineHeight: "150%",
      },
    },
    ".live-board .promotion-area-container .promotion-area-text": {
      "& p": {
        color: "#25282d",
        fontFamily: "Inter-Light",
        fontWeight: "normal",
        fontSize: "2rem",
        lineHeight: "1.5em",
        letterSpacing: "0.03em",
        "@media screen and (max-width: 990px)": {
          fontSize: "1.25rem",
        },
      },
      "& h1": {
        color: "#25282d",
        fontFamily: "LexendDeca-Bold",
        fontWeight: "bold",
        fontSize: "3.6rem",
        lineHeight: "1.25",
        "@media screen and (max-width: 990px)": {
          fontSize: "2.7rem",
        },
      },
    },
    ".live-board .promo-area-1 .promotion-area-text h1": {
      fontFamily: "LexendDeca-Bold",
      fontWeight: "bold",
      fontSize: "2.6rem",
      lineHeight: "125%",
    },
    ".live-board .promo-area-1 .promotion-area-text p": {
      fontFamily: "LexendDeca-Light",
      fontWeight: "normal",
      fontSize: "2rem",
      lineHeight: "150%",
      color: "#25282d",
    },
    ".live-board-desktop .items-header .categories-container .categories-renderer>*":
    {
      fontFamily: "Inter-Light",
      fontWeight: "normal",
      fontSize: "1.4rem",
      color: "#25282d !important",
    },
    ".live-board-desktop .board-content-container .positioning-container .leading-item .description-container p":
    {
      color: "#25282d",
    },
    ".live-board-desktop .items-header .categories-container.tab .show-arrows .categories-renderer .category":
    {
      color: "#484B58",
    },
    ".live-board-desktop .feature-content-container .item-tile-container": {
      display: 'flex',
      overflowX:'auto',
    },
    ".live-board-desktop .item-tile-container .item-tile .item-title": {
      fontFamily: "Inter-Light",
      fontSize: "1.6rem",
      lineHeight: "2rem",
      color: "#25282d",
    },
    ".live-board .positioning-container .positioning-text": {
      "& h1": {
        color: "#25282d",
        fontFamily: "LexendDeca-Bold",
        fontWeight: "bold",
        fontSize: "3.6rem",
        lineHeight: "1.25",
        "@media screen and (max-width: 990px)": {
          fontSize: "2.7rem",
        },
      },
      "& p": {
        color: "#25282d",
        fontFamily: "Inter-Light",
        fontWeight: "normal",
        fontSize: "2rem",
        lineHeight: "1.5em",
        letterSpacing: "0.03em",
        "@media screen and (max-width: 990px)": {
          fontSize: "1.75rem",
        },
      },
    },
    ".positioning-wrapper": {
      background: "#faf9f7 !important",
    },
    a: {
      textDecoration: "none",
    },
    ".board-content > .items-view-container": {
      paddingTop: "7rem !important",
    },
    ".live-board-desktop .items-header .categories-container.tab .categories-renderer .category.active":
    {
      backgroundColor: "#BFDA33 !important",
      color: "#25282D !important",
    },
    ".live-board .promotion-area-container .custom-cta-btn .promotion-cta-button, .flz-btn promotion-cta-button flz-btn-medium flz-btn-secondary":
    {
      color: "white !important",
      backgroundColor: "#C93995",
      border: "2px solid #C93995 !important",
      borderRadius: "3px",
      fontFamily: "LexendDeca-Light",
      fontWeight: "normal",
      fontSize: "1.5rem",
      "& label": {
        fontFamily: "LexendDeca-Light",
        fontWeight: "normal",
        fontSize: "1.5rem",
      },
    },
    ".live-board-desktop .items-view-container": {
      backgroundColor: "#FAF9F7",
    },
    ".live-board-desktop .board-content-container .description-container": {
      backgroundColor: "#bfda33 !important",
      color: "#25282d !important",
    },
    ".live-board-desktop .items-header .categories-container .selected-subcategory": {
      color: "#25282d !important",
    },
    ".live-board-desktop .items-view-container .items-view-content": {
      padding: "0 !important",
    },
    ".ReactModal__Overlay.ReactModal__Overlay--after-open.modal-overlay.item-modal-overlay":
    {
      height: "unset",
      top: "65px !important",
      "@media screen and (min-width: 992px)": {
        top: "100px !important",
      },
      "@media screen and (min-width: 1200px)": {
        top: "152px !important",
      },
    },
    ".desktop-modal-portal.classic-theme .item-modal-body.item-modal-body--after-open:not(.show-header)": {
      paddingTop: '3rem',
      height: 'calc(100% - 6rem)',
      paddingBottom: '3rem',
    },
    ".live-board-mobile .item-tile-container .item-tile .details": {
      backgroundColor: "#FFF",
    },
    ".live-board-mobile .item-tile-container .item-tile": {
      width: "100% !important",
    },
    ".live-board-mobile .items-view-container": {
      paddingTop: "10px",
    },
    ".categories-renderer": {
      "& div ul": {
        overflow: "inherit !important",
      },
    },
    ".items-view-content": {
      "& .items-header": {
        // Following conversation with Dima we decided to disable it
        // position: "sticky",
        // top: "109px",
        zIndex: "1",
        background: "#FFF",
        borderRadius: "15px",
        "@media screen and (max-width: 767px)": {
        // Following conversation with Dima we decided to disable it
          // top: "55px",
        },
      },
    },
    ".live-board .promotion-area-container .custom-cta-btn .promotion-cta-button":
    {
      borderRadius: "3px",
      backgroundColor: "#C93995 !important",
      color: "#FFF !important",
    },
    ".live-board-desktop .items-header .categories-container.tab .categories-renderer>div:last-child":
    {
      display: "none",
    },
  },
});

export function Styles() {
  useGlobalStyle();

  return <div />;
}
